import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";

export interface IYoutubeVideo {
    videoId: string;
    title: string;
    published: string;
    thumbnail: string;
}

const httpService = new HTTPService();

const getLatest = (count = 6): Promise<IHTTPResponse<IAPIResponse<IYoutubeVideo>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.YoutubeVideos}?count=${count}`;
    return httpService.get(url);
};

const VideoService = { getLatest };
export default VideoService;
